import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { AgentCard } from '../agent-card'

const AgentCardWrapper = styled.div`
  padding: 10px 0;
`

interface Props {
  agents: any[]
}

export const RentsMobile: ComponentType<Props> = ({ agents }) => (
  <Container>
    <Row>
      <Col>
        {agents.map(agent => (
          <AgentCardWrapper key={agent.uuid}>
            <AgentCard agent={agent} />
          </AgentCardWrapper>
        ))}
      </Col>
    </Row>
  </Container>
)
